export const EMAIL_SESSION_STORAGE_KEY = 'username';
